const listaDeGrupos = (state) => {
    return state.items;
}

const loadingGrupos = (state) => {
    return state.carregando;

}

export {
    listaDeGrupos,
    loadingGrupos
}